export function flattenEAFormData(data, opts = {}) {
  const { includeNull = false, deepWins = true } = opts;
  if (!data || typeof data !== "object") return {};

  const out = {};

  // ------- 先寫入「非階層」key（如 selectedCom, companyId 等） -------
  Object.keys(data).forEach((key) => {
    if (Number.isNaN(Number(key))) {
      const val = data[key];

      // 如果是 array（像 selectedCom:[{ companyId:xxx }]）
      if (Array.isArray(val) && val.length > 0 && typeof val[0] === "object") {
        Object.keys(val[0]).forEach((k) => {
          const v = val[0][k];
          if (includeNull || (v !== null && v !== undefined && v !== "")) {
            out[k] = v;
          }
        });
      }
      // 如果是單純值
      else if (!Array.isArray(val)) {
        if (includeNull || (val !== null && val !== undefined && val !== "")) {
          out[key] = val;
        }
      }
    }
  });

  // ------- 再處理數字階層 -------
  const levels = Object.keys(data);
  const numLevels = levels
    .filter((k) => !Number.isNaN(Number(k)))
    .map(Number)
    .sort((a, b) => a - b)
    .map(String);

  const orderedLevels = deepWins ? numLevels : [...numLevels].reverse();

  orderedLevels.forEach((L) => {
    const arr = Array.isArray(data[L]) ? data[L] : [];
    arr.forEach((obj) => {
      Object.keys(obj || {}).forEach((key) => {
        const val = obj[key];
        if (includeNull || (val !== null && val !== undefined)) {
          out[key] = val; // 深/淺層覆蓋邏輯照舊
        }
      });
    });
  });

  return out;
}
